import { render, staticRenderFns } from "./control-duration.vue?vue&type=template&id=2decdcc5&scoped=true"
import script from "./control-duration.vue?vue&type=script&lang=js"
export * from "./control-duration.vue?vue&type=script&lang=js"
import style0 from "./control-duration.vue?vue&type=style&index=0&id=2decdcc5&lang=scss&scoped=true"
import style1 from "./control-duration.vue?vue&type=style&index=1&id=2decdcc5&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2decdcc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2decdcc5')) {
      api.createRecord('2decdcc5', component.options)
    } else {
      api.reload('2decdcc5', component.options)
    }
    module.hot.accept("./control-duration.vue?vue&type=template&id=2decdcc5&scoped=true", function () {
      api.rerender('2decdcc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-service/device-data/control-duration.vue"
export default component.exports